import { useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";

export const useTeamDetailsPopup = ({ projectId, details }) => {

    const [filterValues, setFilterValues] = useState({ category: details?.data, is_current: true });
    const [loader, setLoader] = useState(false);
    const [rowData, setRowData] = useState([{ id: "all", key: "", children: [] }]);
    const [worklogDetails, setWorklogDetails] = useState({ visible: false, group: {} });
    const columns = [
        {
            key: "user_display_name",
            label: "Name",
            style: { width: "20%" },
            render: (row) => {
                return (
                    <div className="p-2">{row?.user_display_name}</div>
                )
            }
        },
        {
            key: "user_role_name",
            label: "Role",
            style: { width: "20%" },
            render: (row) => {
                return (
                    <div className="p-2">{row?.project_role_name}</div>
                )
            }
        },
        {
            key: "worklog",
            label: "Worklog Summary",
            style: { width: "30%" },
            sort: false,
            render: (row) => {
                return (
                    <div className="p-2 d-flex gap-3 flex-wrap">
                        {row?.worklog?.map(item => (
                            (item?.logged_hours === "-" ? 0 : item?.logged_hours) ?
                            <div className="d-flex gap-2">
                                <div>{item?.issue_type_group_name}</div>
                                <div className="fw-bold text-decoration-underline c-pointer" onClick={() => { if (item?.issue_type_group_id) { setWorklogDetails((prev) => ({ ...prev, visible: true, group: item, requested_user_code: item?.user_code })); } }}>{item?.logged_hours === "-" ? 0 : item?.logged_hours}h</div>
                            </div> : ""
                        ))}
                    </div>
                )
            }
        },
        {
            key: "communicators",
            label: "Communicators",
            style: { maxWidth: "30%", width: "30%" },
            sort: false,
            render: (row) => {
                const names = _.uniq(row?.communicator_category_names?.split(","))?.toString()
                return (
                    <div className="px-2 text-truncate" title={names}>{names}</div>
                )
            }
        },
    ]

    useEffect(() => {
        getTeamDetails();
    }, [filterValues?.category, filterValues?.is_current])

    const getTeamDetails = async () => {
        try {
            setLoader(true);
            const payload = {
                project_id: projectId,
                team_category_id: filterValues?.category?.category_id || 0,
                is_current: filterValues?.is_current
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTTEAMCOMPOSITIONDETAIL"), payload);
            if (res) {
                const data = res?.body?.data?.project_composition_detail;
                let teamDetails = [];
                _.uniq(_.pluck(data, "user_code"))?.forEach(item => {
                    const filteredData = _.filter(data, user => user?.user_code === item);
                    if (!_.isEmpty(filteredData)) {
                        let dataObj = filteredData?.[0];
                        dataObj["worklog"] = filteredData;
                        teamDetails?.push(dataObj);
                    }
                })
                setRowData([{ id: "all", key: "", children: teamDetails }]);
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
        }
    }

    return useMemo(() => ({
        filterValues, setFilterValues, loader, columns, rowData, worklogDetails, setWorklogDetails
    }), [filterValues, setFilterValues, loader, columns, rowData, worklogDetails, setWorklogDetails])
}